import React from 'react';

const ShiftSection = () => {
  return (
    <section className="py-24 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center max-w-4xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white">
            Three Products. <span className="text-cyan-400">One Intelligent Platform.</span>
          </h2>
          <p className="text-2xl md:text-3xl text-white font-semibold leading-relaxed">
            AI Training, Role-Play & Marketplace<br /><span className="text-cyan-400">For Enterprise</span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ShiftSection;
